import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ConfirmationModalContext = /*#__PURE__*/createContext(null);
const ConfirmationModalProvider = ({
  children
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [onConfirm, setOnConfirm] = useState(() => () => {});
  const [onDecline, setOnDecline] = useState(() => () => {});
  return /*#__PURE__*/_jsx(ConfirmationModalContext.Provider, {
    value: {
      isOpen,
      onConfirm,
      onDecline,
      setIsOpen,
      setOnConfirm,
      setOnDecline
    },
    children: children
  });
};
export const useConfirmationModal = () => {
  const context = useContext(ConfirmationModalContext);
  if (!context) {
    throw new Error('useConfirmationModal must be used within a ConfirmationModalProvider');
  }
  return context;
};
export default ConfirmationModalProvider;
//# sourceMappingURL=ConfirmationModalContext.js.map